import React from 'react';
import {useDispatch} from 'react-redux';
import {logOmniClick} from '@ibibo/analytics';
import * as S from './DeleteGstModal.styles';
import {deleteTravelGstUrl} from '../../../../../../shared/CommonConfigs/url';
import {makePostRequest} from '@ibibo/myaccount-reducer';
const DeleteGstModal = ({modalData, closeModal}) => {
  const dispatch = useDispatch();
  const {gstOwner, companyName, gstNumber, billingAddress} = modalData || {};

  const clickHandler = () => {
    logOmniClick('mysettings:gst', {
      prop54: `CTA –Delete_GST_Clicked `,
    });
    dispatch(
      makePostRequest(
        deleteTravelGstUrl,
        {travellerGstId: modalData?.travellerGstId},
        () => {
          window.location.reload();
        },
        () => {},
      ),
    );
  };

  return (
    <S.DeleteGstModal>
      <p className="makeFlex">
        <span className="sprite icExclaimRedBg"></span>
        <span className="mdlHeading">Delete Saved GSTN</span>
      </p>
      <p className="mdlSubHeading">Are you sure you want to delete this saved GSTN?</p>
      <S.DeleteGstCard background="#f6f6f6">
        <p className="makeFlex">
          <span className="cardHeading">{companyName}</span>
          <span className="cardTag">{gstOwner}</span>
        </p>
        <p className="cardSubHeading">{billingAddress}</p>
        <p className="cardSubHeadingTwo">GSTIN: {gstNumber}</p>
      </S.DeleteGstCard>
      <S.mdlCtaWrap>
        <S.ctaItem color="#008cff" onClick={closeModal}>
          NO, GO BACK
        </S.ctaItem>
        <S.ctaItem onClick={clickHandler} color="#008cff" margin="0px 0px 0px 8px">
          YES, DELETE
        </S.ctaItem>
      </S.mdlCtaWrap>
    </S.DeleteGstModal>
  );
};

export default DeleteGstModal;
